import FiltersActions, { FiltersActionType } from './../actions/filtersActions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Services, GetFiltersResponse } from '@card/commonlib';

function* fetchFilters() {
  try {
    const response: GetFiltersResponse = yield call(Services.getFilters);
    yield put(FiltersActions.fetchSuccess(response));
  } catch (error) {
    yield put(FiltersActions.fetchError(error));
  }
}

function* filtersSagas() {
  yield takeLatest(FiltersActionType.Fetch, fetchFilters);
}

export default filtersSagas;
